import { useMemo } from "react";
import { InputFieldProps } from "./types";
import { FilterableSelect, MultiSelect } from "../GenericInputComponents";

export const EnumInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate }) => {
	if (inputField.type !== "enum") {
		return <>non-enum types are currently not supported</>;
	}

	const isMultiSelect = !!inputField.isMultiSelect;

	const placeholderText = useMemo(() => {
		const inputFieldName = inputField.name
			.replace(/([A-Z])/g, " $1")
			.replace(/^./, (s) => s.toUpperCase())
			.toLowerCase()
			.trim();
		return `Please select a(n) ${inputFieldName}`;
	}, [inputField.name]);

	return isMultiSelect ? (
		<MultiSelect options={inputField.values} onUpdate={(value) => onUpdate?.(value)} values={inputValue} placeholder={placeholderText} />
	) : (
		<FilterableSelect options={inputField.values} onSelect={(value) => onUpdate?.(value)} value={inputValue} placeholder={placeholderText} />
	);
};
